// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"524":"0b7a13a3","649":"48fa368f","787":"2122d6a9","812":"2e73c19f"}[chunkId] + ".chunk.js";
};